/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { DeleteVideoEditorProjectsProjectMutationResponse, DeleteVideoEditorProjectsProjectPathParams } from "../models/DeleteVideoEditorProjectsProject";

export function getDeleteVideoEditorProjectsProjectUrl(id: DeleteVideoEditorProjectsProjectPathParams["id"]) {
  const res = { method: 'DELETE', url: `/video-editor/projects/${id}` as const }
  return res
}

/**
 * @summary Delete a project
 * {@link /video-editor/projects/:id}
 */
export async function deleteVideoEditorProjectsProject(id: DeleteVideoEditorProjectsProjectPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DeleteVideoEditorProjectsProjectMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getDeleteVideoEditorProjectsProjectUrl(id).url.toString(), ... requestConfig })
  return res.data
}